import React, { Component, createRef }from 'react';
import 'antd/dist/antd.css';
import { Table } from 'antd';
import { Card, CardBody } from "reactstrap";

  class TableWidgets extends Component {
    constructor(props){
      super(props);
      this.state = {
          tableData : props.widgetItem,
          searchText: '',
          searchedColumn: '',
          tableParams: ''
      }
      this.searchInput = createRef(null);
    }
      componentDidMount() {
      }


    render() {
      const  { tableData } = this.state;

      let renderDatas = tableData.bind;
      let tabData = {};
      if(renderDatas.hasOwnProperty('data')){
        if(renderDatas.data !== null && renderDatas.data !== undefined){
          var parseData = renderDatas.data; 
          // From URL
          if(typeof parseData === "object"){
            tabData = parseData;
          } 
          // FROM JSON
          else {
              tabData = JSON.parse(parseData);
          }
        }
      }


      return (
        <div className='df-table-wid'>
          <h3 className="wd-header mb-4">{tableData.title !== null && tableData.title !== undefined ? tableData.title : ''}</h3>
          {tabData !== null && tabData !== undefined && tabData.columns !== null && tabData.columns !== undefined && tabData.dataSource !== null && tabData.dataSource !== undefined ? <Table className='df-ant-tab' columns={tabData.columns} dataSource={tabData.dataSource} scroll={{ y: 400 }} /> :
            <Card className='p-3'>
              <CardBody className='p-0'>
                <div className='df-tab-wid'>
                  <p className='font-weight-normal text-danger font-weight-bold font12 m-0'>
                    <span>Table widget render failed</span>
                  </p>
                </div>
              </CardBody>
            </Card>
          }
        </div>
      )
    }
  }



  export default TableWidgets;